import PortfolioPage from "./PortfolioPage";

export default function TrendyHairstylesPage() {
  return (
    <PortfolioPage
      pageType="trendy-hairstyles"
      title="Trendy Hairstyles"
      subtitle="Discover the latest hair styling trends and techniques"
    />
  );
}
